import { CommonModule, NgClass, NgIf } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'fds-resize-vertical-tracker',
    templateUrl: './resize-vertical-tracker.component.html',
    styleUrls: ['./resize-vertical-tracker.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf]
})
export class ResizeVerticalTrackerComponent {
  @Input() completed = false;

  @Input() disabled = false;

  @Input() active = true;

  @Input() inProgress = false;

  @Input() firstItem = false;

  @Input() simple = false;

  @Input() label = '';
}

@NgModule({
    imports: [CommonModule, FormsModule, ResizeVerticalTrackerComponent],
    exports: [ResizeVerticalTrackerComponent, FormsModule],
    providers: []
})
export class ResizeVerticalTrackerModule {}
